module.exports = __webpack_public_path__ + "img/ico-cyber.248b04eb.svg";